var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959",
    transform: "translate(-711.429 -2647.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(714.86 2650.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M19.155,0H16.738A2.418,2.418,0,0,0,14.32,2.418V4.835a2.418,2.418,0,0,0,2.418,2.418h2.418a2.418,2.418,0,0,0,2.418-2.418V2.418A2.418,2.418,0,0,0,19.155,0",
    transform: "translate(-3.433 0)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M4.835,0H2.418A2.418,2.418,0,0,0,0,2.418V4.835A2.418,2.418,0,0,0,2.418,7.253H4.835A2.418,2.418,0,0,0,7.261,4.835V2.418A2.418,2.418,0,0,0,4.835,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M19.155,14.32H16.738a2.418,2.418,0,0,0-2.418,2.418v2.418a2.418,2.418,0,0,0,2.418,2.418h2.418a2.418,2.418,0,0,0,2.418-2.418V16.738a2.418,2.418,0,0,0-2.418-2.418",
    transform: "translate(-3.433 -3.433)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M4.835,14.32H2.418A2.418,2.418,0,0,0,0,16.738v2.418a2.418,2.418,0,0,0,2.418,2.418H4.835a2.418,2.418,0,0,0,2.425-2.418V16.738A2.418,2.418,0,0,0,4.835,14.32",
    transform: "translate(0 -3.433)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.07dd3442f66f944881acaf9bb8d9e47a.svg";
export { ForwardRef as ReactComponent };